(() => {
  const CFG = window.__FREE_GIFT__ || {};
  const THRESHOLD = Number(CFG.threshold || 125);
  const GIFT_VARIANT_ID = Number(String(CFG.variantId || '').trim());

  if (!GIFT_VARIANT_ID) {
    console.warn('[FreeGift] Missing variant id in theme settings');
    return;
  }

  const LOCK_KEY = '__free_gift_lock__';

  const sectionsPayload = () => ({
    sections: 'cart-drawer,cart-icon-bubble',
    sections_url: window.location.pathname
  });

  const getCartDrawer = () => document.querySelector('cart-drawer');

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }

  function cartHasGift(cart) {
    return cart.items?.some(i => Number(i.variant_id) === GIFT_VARIANT_ID);
  }

  function giftLineItem(cart) {
    return cart.items?.find(i => Number(i.variant_id) === GIFT_VARIANT_ID);
  }

  // Щоб поріг рахувався "по товарах без подарунка"
  function cartTotalWithoutGiftCents(cart) {
    const gift = giftLineItem(cart);
    return (cart.total_price || 0) - (gift ? (gift.final_line_price ?? gift.line_price ?? 0) : 0);
  }

  async function addGift() {
    const fd = new FormData();
    fd.append('id', String(GIFT_VARIANT_ID));
    fd.append('quantity', '1');
    const sp = sectionsPayload();
    fd.append('sections', sp.sections);
    fd.append('sections_url', sp.sections_url);

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd
    });
    return res.json();
  }

  async function removeGift(cart) {
    const gift = giftLineItem(cart);
    if (!gift) return null;

    const fd = new FormData();
    // Для /cart/change.js можна передавати line item key
    fd.append('id', gift.key);
    fd.append('quantity', '0');
    const sp = sectionsPayload();
    fd.append('sections', sp.sections);
    fd.append('sections_url', sp.sections_url);

    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd
    });
    return res.json();
  }

  function rerenderDrawer(data) {
    const drawer = getCartDrawer();
    if (drawer && typeof drawer.renderContents === 'function' && data) {
      drawer.renderContents(data);
      if (typeof drawer.open === 'function') drawer.open();
    }
  }

  async function syncFreeGift() {
    // запобігаємо рекурсії, бо ми самі міняємо кошик
    if (sessionStorage.getItem(LOCK_KEY) === '1') return;

    sessionStorage.setItem(LOCK_KEY, '1');

    try {
      const cart = await fetchCart();
      const totalNoGiftCents = cartTotalWithoutGiftCents(cart);
      const qualifies = totalNoGiftCents >= THRESHOLD * 100;

      const hasGift = cartHasGift(cart);

      if (qualifies && !hasGift) {
        const data = await addGift();
        rerenderDrawer(data);
      } else if (!qualifies && hasGift) {
        const data = await removeGift(cart);
        rerenderDrawer(data);
      }
    } catch (e) {
      console.error('[FreeGift] sync error', e);
    } finally {
      // невелика пауза, щоб не ловити “дубль” при каскадних апдейтах
      setTimeout(() => sessionStorage.removeItem(LOCK_KEY), 300);
    }
  }

  // 1) при завантаженні сторінки
  document.addEventListener('DOMContentLoaded', () => {
    syncFreeGift();
  });

  // 2) перехоплюємо cart-запити (add/change/update/clear) і після них синхронізуємо подарунок
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const res = await origFetch(...args);

    try {
      const url = String(args[0] || '');
      const isCartEndpoint =
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear');

      if (isCartEndpoint) {
        // трохи пізніше, щоб Dawn встиг оновити DOM
        setTimeout(syncFreeGift, 150);
      }
    } catch (_) {}

    return res;
  };

  // 3) коли відкривається drawer — теж перевіряємо
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('a[href="/cart"], button[name="open-cart-drawer"], [data-open-cart-drawer]');
    if (opener) setTimeout(syncFreeGift, 150);
  });
})();
